import { ReactNode } from 'react'
import { BsFillCaretDownFill, BsFillCaretRightFill } from 'react-icons/bs'

import styled, { css } from 'styled-components'

import { Colours } from '@lib/theme'

import { CSSBase } from './CSSBase'

const CSSCollapseButton = css`
  border: none;
  background-color: transparent;
  color: ${Colours.Brand.BlueMid};

  width: 100%;
  padding: 0.4rem 0.25rem;
  border-radius: 0;

  :hover {
    background-color: ${Colours.FgShade.Lighter};
    color: ${Colours.Brand.BlueMid};

    filter: brightness(1);
  }

  :active {
    filter: brightness(0.9);
  }

  transition: all 0.15s ease-in-out;
`

export interface StyledButtonProps {
  children: ReactNode
  isExpanded: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const StyledButton = styled.button`
  ${CSSBase}

  ${CSSCollapseButton}
`
export type StyledProps = {
  children: ReactNode
  isExpanded: boolean
} & StyledButtonProps

export function CollapseButton({
  children,
  isExpanded,
  ...props
}: StyledProps) {
  return (
    <StyledButton {...props} id="collapse-btn">
      {isExpanded ? <BsFillCaretDownFill /> : <BsFillCaretRightFill />}
      <div>{children}</div>
    </StyledButton>
  )
}
